import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
    CardElement,
    Elements,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import config from "../../config";

const stripePromise = loadStripe(config.stripePK);

const CheckoutForm = ({ stripeTokenHandler }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [paybutton, setPayButton] = useState(true);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (elements == null) {
            return;
        }
        const cardElement = elements.getElement(CardElement);
        const payload = await stripe.createToken(cardElement);
        if (payload?.token?.id) {
            stripeTokenHandler(payload.token.id);
            return;
        } else {
            return;
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <CardElement
                    onChange={(e) => {
                        if (e.complete) {
                            setPayButton(false);
                        } else {
                            setPayButton(true);
                        }
                    }}
                />
                <br />

                <ul className="list-inline">
                    <li>
                        <button
                            type="submit"
                            className="btn btn-primary stripePay-Btn btn "
                            disabled={!stripe || !elements || paybutton}
                        >
                            {!stripe || !elements || paybutton
                                ? "Enter Card Details to Continue"
                                : "Save & Continue"}
                        </button>
                    </li>
                </ul>
            </form>
        </>
    );
};

const StripeForm = (props) => {
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm stripeTokenHandler={props.stripeTokenHandler} />
        </Elements>
    );
};

export default StripeForm;
